<template>
  <v-select
    v-model="selected"
    :menu-props="{ top: true, offsetY: true, nudgeTop: 6 }"
    :items="langList"
    class="c-language-select"
    color="primary"
    height="36"
    hide-details
    dense
    @change="changeLocalLang">
    <template #item="{ item }">
      <v-icon size="20" class="mr-2">{{ `$${item.toLowerCase()}` }}</v-icon>
      {{ item }}
    </template>
    <template #message="{ message }">
      {{ $t(message) }}
    </template>
    <template #selection>
      <v-icon size="20" class="mx-2">{{ `$${selected.toLowerCase()}` }}</v-icon>
      {{ selected }}
    </template>
  </v-select>
</template>
<script>
import { languageList } from '@/plugins/i18n';
import { loadBackendTranslations, loadSpecialitiesTranslations, loadWhiteLabel } from '@/common/preload/startAppFunctions';
// import { loadRecaptchaScript } from '@/common/recaptcha';
import 'moment/locale/en-gb';
import 'moment/locale/fr';
import 'moment/locale/ru';
import 'moment/locale/es';
import 'moment/locale/az';
import 'moment/locale/ar';
import 'moment/locale/de';
import 'moment/locale/ms';
import 'moment/locale/id';
import 'moment/locale/zh-cn';

export const momentLang = {
  en: 'en-gb',
  es: 'es',
  ru: 'ru',
  az: 'az',
  ar: 'ar',
  du: 'de',
  ms: 'ms',
  in: 'id',
  zhm: 'zh-cn',
  fr: 'fr',
};

export default {
  name: 'LanguageSelect',
  props: {
    language: {
      type: String,
      default: null,
    },
    w100: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    langList() {
      return languageList.map((item) => item.toUpperCase());
    },
  },
  mounted() {
    this.selected = this.$i18n.locale.toUpperCase();
    this.setRtl(this.$i18n.locale);
    this.$moment.locale(momentLang[this.$i18n.locale]);
  },
  methods: {
    changeLocalLang(languageToChange) {
      const lang = languageToChange.toLowerCase();

      localStorage.setItem('language', lang);

      this.$i18n.locale = lang;
      this.$vuetify.lang.current = lang;
      this.$moment.locale(momentLang[lang]);

      this.setRtl(lang);
      // loadRecaptchaScript();
      loadWhiteLabel();
      loadBackendTranslations(lang);
      loadSpecialitiesTranslations(lang);
    },
    setRtl(lang) {
      this.$vuetify.rtl = lang === 'ar';
    },
  },
};
</script>
